var map = {
  "./media.1.json": [
    "38369"
  ],
  "./note.contextId-9b0726fd-bca2-4bf9-b331-507e4e41ff1d.json": [
    "33045"
  ],
  "./query.tasks.json": [
    "55816"
  ],
  "./9788245087444.json": [
    "26754"
  ],
  "./agent.35556133-555c-4bfd-bece-90822db8ff4b.json": [
    "82568"
  ],
  "./media.3.json": [
    "48359"
  ],
  "./manualapproval.changerequest.ean_ean-9788202842130.json": [
    "56216"
  ],
  "./work.v2.4e45e65c-71e7-444f-8372-8b4b9ee4b8a9.json": [
    "72411"
  ],
  "./manifestation.9b0726fd-bca2-4bf9-b331-507e4e41ff1d.media.json": [
    "40008"
  ],
  "./agent.c875d125-2e2e-422d-a8a8-0c6c931a87b8.json": [
    "22915"
  ],
  "./media.2.json": [
    "53972"
  ],
  "./media.4.json": [
    "29066"
  ],
  "./work.v2.e2f0861f-13b2-48e1-838b-afc64e511285.json": [
    "57273",
    "498"
  ],
  "./query.manifestation.isbn.9788202098087.json": [
    "91662"
  ],
  "./manifestation.isbn.json": [
    "76848"
  ],
  "./search.agents.json": [
    "82712",
    "489"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 16045;
module.exports = __rspack_async_context;
